// extracted by mini-css-extract-plugin
export var deleteModal = "_fr-0";